import { HashRouter, Routes } from '@/router/HashRouter';
import { el, icon } from '@/utils/dom';

const NAV_ITEMS: { route: string; label: string; icon: 'calculator' | 'book' | 'settings' }[] = [
  { route: 'calculator', label: 'Calcolatore', icon: 'calculator' },
  { route: 'legend', label: 'Legenda', icon: 'book' },
  // { route: 'settings', label: 'Impostazioni', icon: 'settings' },
];

/** Header con logo, titolo e nav a pagine. */
export function renderHeader(router: HashRouter, currentRoute: string): void {
  const header = document.getElementById('app-header')!;
  header.innerHTML = '';

  const container = el('div', { className: 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 gap-4' });

  // Logo + titolo (clickabile → home)
  const logo = el('a', {
    className: 'flex items-center gap-2.5 group cursor-pointer',
    attrs: { href: '#/calculator' },
  }, [
    el('div', {
      className: 'w-9 h-9 rounded-xl bg-gradient-to-br from-brand-500 to-accent-600 text-white flex items-center justify-center font-bold shadow-sm group-hover:scale-105 transition',
      text: 'Cyb',
    }),
    el('div', { className: 'flex flex-col leading-tight' }, [
      el('span', { className: 'text-sm font-bold text-slate-900', text: 'Calcolatore risparmio' }),
      el('span', { className: 'text-[11px] text-slate-500', text: 'Cybhotel' }),
    ]),
  ]);

  // Nav desktop
  const nav = el('nav', {
    className: 'hidden md:flex items-center gap-1',
    aria: { label: 'Navigazione principale' },
  });
  NAV_ITEMS.forEach((item) => {
    const isActive = item.route === currentRoute;
    const link = el('a', {
      className: `nav-link ${isActive ? 'nav-link-active' : ''}`,
      attrs: { href: `#/${item.route}`, 'aria-current': isActive ? 'page' : 'false' },
    });
    link.appendChild(icon(item.icon));
    link.appendChild(document.createTextNode(item.label));
    nav.appendChild(link);
  });

  // Nav mobile (select)
  const select = el('select', {
    className: 'md:hidden input-base w-auto py-1.5 text-sm',
    aria: { label: 'Navigazione' },
    onChange: (e) => {
      const value = (e.target as HTMLSelectElement).value as Routes;
      router.navigate(value);
    },
  });
  NAV_ITEMS.forEach((item) => {
    const opt = el('option', {
      attrs: { value: item.route },
      text: item.label,
    });
    if (item.route === currentRoute) opt.setAttribute('selected', 'selected');
    select.appendChild(opt);
  });

  container.appendChild(logo);
  container.appendChild(nav);
  container.appendChild(select);
  header.appendChild(container);
}

/** Footer con note legali, contatti, versione. */
export function renderFooter(): void {
  const footer = document.getElementById('app-footer');
  if (!footer) return;
  footer.innerHTML = '';
  const inner =
    el('div', { className: 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid gap-4 sm:grid-cols-3 text-sm text-slate-500' },
      [
        el('div', { className: 'space-y-1' }, [
          el('p', { className: 'font-semibold text-slate-700', text: 'Hotel ROI Calculator' }),
          el('p', { className: 'text-xs', text: 'Strumento dimostrativo per stimare il risparmio e il ROI di un sistema integrato per hotel.' }),
        ]),
        el('div', { className: 'space-y-1' }, [
          el('p', { className: 'font-semibold text-slate-700', text: 'Note legali' }),
          el('p', { className: 'text-xs', text: 'Le stime sono indicative e non costituiscono consulenza finanziaria. Verificare i parametri con il proprio provider.' }),
        ]),
        el('div', { className: 'space-y-1 sm:text-right' }, [
          el('p', { className: 'font-semibold text-slate-700', text: 'Contatti' }),
          el('a', { className: 'text-xs text-brand-700 hover:underline', attrs: { href: 'mailto:info@cybhotel.com' }, text: 'info@cybhotel.com' }),
          el('p', { className: 'text-xs', text: 'Versione 1.0.0' }),
        ]),
      ]);
  footer.appendChild(inner);
}
